import React, { useEffect, useRef } from 'react';
import { breakpoints } from '../../../../../config/constants';
import ArticleCardBase from '../../Base';
import { inheritChildStyle } from '../../../../../helpers/text';

import './styles.scss';

const PortraitSocialEmbedTwitter = ({ data, endCard }) => {
  const { backgroundColor, sectionTitle, caption, twitterPostId } = data;
  const noTitle =
    sectionTitle === null && caption === null ? 'portrait-social-embed-twitter__no-title' : '';
  const twitterWidgetRef = useRef();
  const captionTextRef = useRef();

  function createTwitterWidget() {
    if (window.twttr && twitterWidgetRef.current) {
      const widgetWidth = window.innerWidth < breakpoints.tablet ? window.innerWidth - 48 : 525;

      twitterWidgetRef.current.innerHTML = '';

      window.twttr.widgets.createTweet(twitterPostId, twitterWidgetRef.current, {
        theme: 'light',
        cards: 'hidden',
        conversation: 'none',
        width: widgetWidth,
        align: 'center'
      });
    }
  }

  useEffect(() => {
    const handleResize = () => {
      window.requestAnimationFrame(() => {
        createTwitterWidget();
      });
    };

    if (captionTextRef.current) {
      inheritChildStyle(captionTextRef.current, 'a', 'color');
    }

    window.addEventListener('resize', handleResize);

    createTwitterWidget();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <ArticleCardBase variation="portrait" accentColor1={backgroundColor} endCard={endCard}>
      <section className={`card-container portrait-social-embed-twitter ${noTitle}`}>
        <div
          className="portrait-social-embed-twitter__title"
          dangerouslySetInnerHTML={{ __html: sectionTitle }}
        />
        <div
          ref={captionTextRef}
          className="portrait-social-embed-twitter__caption"
          dangerouslySetInnerHTML={{ __html: caption }}
        />
        <div ref={twitterWidgetRef} className="portrait-social-embed-twitter__embed-wrapper" />
      </section>
    </ArticleCardBase>
  );
};

export default PortraitSocialEmbedTwitter;
